
<div class="auth-page">
    <div class="auth-content">
        <div class="row">
            <div class="col-2">
                <img  style="width: 22px; height: 22px; position: relative; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">

            </div>
            <div class="col-10">
                <img  src="/assets/images/shared/logo.png" style="width: 90px; position: relative; right: 30px; height: 55px; display: block; margin: auto;" alt="">
            </div>
        </div>
        <h1 style="font-weight: bold;">{{  this.pageDetails().title }}</h1>
        <div [formGroup]="this.registrationInfo" class="mb-3">
            <input type="text" class="form-control" formControlName="first_name" placeholder="Име" aria-label="Username" aria-describedby="basic-addon1">
            <input type="text" class="form-control" formControlName="last_name" placeholder="Фамилия" aria-label="Username" aria-describedby="basic-addon1">
            <input type="text" class="form-control" formControlName="email" (input)="this.trim($event.target)" placeholder="Имейл" aria-label="Username" aria-describedby="basic-addon1">
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input [autoClose]="'outside'" [ngbPopover]="popContent" (input)="this.checkPassoword($event.target)" style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control" formControlName="password" placeholder="Парола"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control" formControlName="password_confirmation" placeholder="Потвърди парола"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <div class="alert alert-danger" *ngIf="this.error" role="alert"> {{ this.error }}</div>
        </div>
    </div>
    <div class="auth-actions">
        <p style="color: #ADAFBB; margin-bottom: 5px; ">Вече имам регистрация. <a (click)="this.goToLogin()" style="color: #0A69EB;">Вход</a></p>
        <button  [disabled]="!this.registrationInfo.touched" type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.registration()">Регистрирай се</button>
    </div>
</div>

<ng-template #popContent>
    <p class="popup">
        <span style="font-weight: bold; text-align: left;">Паролата трябва да съдържа</span>
        <br>
        <span [style]="this.isLengthCheckValid ? 'color: green;' : 'color: red;'">поне 8 символа</span>
        <br>
        <span [style]="this.isSmallLettersCheckValid ? 'color: green;' : 'color: red;'">малка буква</span>
        <br>
        <span [style]="this.isCapitalLettersCheckValid ? 'color: green;' : 'color: red;'">главна буква</span>
        <br>
        <span [style]="this.isDigitsCheckValid ? 'color: green;' : 'color: red;'">число</span>
        <br>
        <span [style]="this.isSymbolCheckValid ? 'color: green;' : 'color: red;'">символ</span>
    </p>
</ng-template>
<router-outlet></router-outlet>
